import createCachedSelector from 're-reselect';

const getMyself = ({ myself }) => myself;
const getNature = (state, props) => props.nature;

const cacheKey = getNature;

const inputFuncs = [getMyself, getNature];
const outputFunc = (myself, nature) => myself.qualities
  .filter(q => q.nature === nature) // filter by nature (Thing/Status)
  .map(q => ({
    ...q,
    level: q.effectiveLevel, // use effectiveLevel to show modified quality level
  }));

export default createCachedSelector(inputFuncs, outputFunc)(cacheKey);